import { NavigationProp, useNavigation } from "@react-navigation/native";
import { useAtomValue } from "jotai";

import { BaseNavigatorParamList } from "@/navigators/BaseNavigator/types";
import { DepartmentIcon } from "@whoosh/design-system/src/components/icons_v2/department";
import { DepartmentType } from "@whoosh/design-system/src/components/icons_v2/department";
import {
  Box,
  HStack,
  Pressable,
  Text,
} from "@whoosh/design-system/src/components/primitive";
import { useTodaysDate } from "@whoosh/utilities/src/dates";

import { VerificationModalStepStateAtom } from "../../../../atoms/stores";

type WelcomeStepFacilityEntryProps = {
  name: string;
  facilitySlug: string;
  departmentType: DepartmentType;
  isLast: boolean;
  clubSlug: string;
};

export const WelcomeStepFacilityEntry = ({
  name,
  facilitySlug,
  departmentType,
  isLast,
  clubSlug,
}: WelcomeStepFacilityEntryProps) => {
  const navigation = useNavigation<NavigationProp<BaseNavigatorParamList>>();
  const curDate = useTodaysDate();
  const verificationStepData = useAtomValue(VerificationModalStepStateAtom);
  const emailOrPhone =
    verificationStepData.step === "Welcome"
      ? verificationStepData.emailOrPhone
      : undefined;

  const navigateToFacilityPage = (facilitySlug: string) => {
    navigation.navigate("Club", {
      clubSlug,
      screen: "Agenda",
      params: {
        facilitySlug,
        date: curDate,
        emailOrPhone,
      },
    });
  };

  return (
    <Pressable onPress={() => navigateToFacilityPage(facilitySlug)}>
      <HStack
        gap={4}
        alignItems="center"
        paddingVertical={4}
        borderBottomWidth={isLast ? 0 : 1}
        borderBottomColor="outline-default"
      >
        <Box
          width={48}
          height={48}
          backgroundColor="surface-secondary"
          borderRadius="2"
          alignItems="center"
          justifyContent="center"
        >
          <DepartmentIcon type={departmentType} />
        </Box>
        <Text variant={"mainBaseMedium"}>{name}</Text>
      </HStack>
    </Pressable>
  );
};
